export enum MixerEventTypes {
    MixersUpdated = "mixers_updated"
}
